<div class="dialog-overlay">
  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <div class="icon-wrapper">
          <mat-icon>check_circle</mat-icon>
        </div>
        <div>
          <h2 class="title">Payment Confirmed</h2>
          <p class="subtitle">Your pickup has been scheduled</p>
        </div>
      </div>

      <div class="invoice-card">
        <p class="invoice-label">Invoice Number</p>
        <p class="invoice-number">{{ item.InvoiceNo }}</p>
      </div>
    </div>

    <mat-dialog-content class="dialog-content">
      <div class="location-grid">
        <div class="location-card">
          <div class="location-header">
            <mat-icon>inventory_2</mat-icon>
            <span>Source Branch</span>
          </div>
          <p class="location-value">{{ item.BranchName }}</p>
        </div>

        <div class="location-card">
          <div class="location-header">
            <mat-icon>place</mat-icon>
            <span>Delivery Zone</span>
          </div>
          <p class="location-value">{{ item.DeliveryZoneCode }}</p>
        </div>
      </div>

      <div>
        <h3 class="title-section">Shipment Items</h3>
        <div class="box-items">
          <div
            *ngFor="let boxItem of item.invoiceItemDetailList"
            class="box-item"
          >
            <div class="box-grid">
              <div>
                <p class="box-label">Box Size</p>
                <p class="box-value">{{ boxItem.boxSizeDescription }}</p>
              </div>
              <div>
                <p class="box-label">Dimension</p>
                <p class="box-value">{{ boxItem.dimension }}</p>
              </div>
              <div>
                <p class="box-label">Price</p>
                <p class="box-price">{{ boxItem.unitPrice }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h3 class="title-section">Order Summary</h3>
        <div class="summary-card">
          <div class="summary-row">
            <span class="summary-label">Order Amount</span>
            <span class="summary-value"
              >{{ currency[item.BillingCountry]
              }}{{ item.Freight | number : "1.2-2" }}</span
            >
          </div>

          <div class="summary-row">
            <span class="summary-label">Tip Amount</span>
            <span class="summary-value"
              >{{ currency[item.BillingCountry]
              }}{{ (item.Tip != null ? item.Tip : 0) | number : "1.2-2" }}</span
            >
          </div>

          <div class="summary-row">
            <span class="summary-label">Merchant Fee</span>
            <span class="summary-value"
              >{{ currency[item.BillingCountry]
              }}{{
                (item.MerchantFee != null ? item.MerchantFee : 0)
                  | number : "1.2-2"
              }}</span
            >
          </div>

          <div class="summary-row">
            <span class="summary-label">Less Discount</span>
            <span class="discount-value"
              >- {{ currency[item.BillingCountry]
              }}{{
                (item.Discount != null ? item.Discount : 0) | number : "1.2-2"
              }}</span
            >
          </div>

          <div class="summary-divider"></div>

          <div class="summary-total">
            <span class="total-label">Total Amount</span>
            <span class="total-value"
              >{{ currency[item.BillingCountry] }}
              {{
                (item.TotalAmount != null ? item.TotalAmount : 0)
                  | number : "1.2-2"
              }}</span
            >
          </div>
        </div>
      </div>

      <div>
        <h3 class="title-section">Payment Method</h3>
        <div *ngFor="let payment of item.Payments" class="payment-card">
          <div class="payment-header">
            <div>
              <div class="payment-name">
                <mat-icon>credit_card</mat-icon>
                <span>{{ payment.PaymentName }}</span>
              </div>
              <p class="payment-date">
                {{ payment.PaymentDate | date : "MMM dd, yyyy" }}
              </p>
            </div>
            <div class="payment-amount">
              $ {{ payment.PaymentAmount | number : "1.2-2" }}
            </div>
          </div>

          <div
            *ngIf="payment.CardType || payment.CreditCardNumber"
            class="payment-details"
          >
            <p *ngIf="payment.CardType">{{ payment.CardType }}</p>
            <p *ngIf="payment.CreditCardNumber" class="card-number">
              {{ payment.CreditCardNumber }}
            </p>
            <p *ngIf="payment.CreditCardExpDate">
              Exp: {{ payment.CreditCardExpDate | date : "MM/yyyy" }}
            </p>
            <p *ngIf="payment.CheckNo">Check #{{ payment.CheckNo }}</p>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <!-- <button mat-stroked-button class="btn btn-outline-success">
        Download Receipt
      </button> -->
      <button mat-raised-button class="btn btn-success" (click)="cancel()">
        Close
      </button>
    </mat-dialog-actions>
  </div>
</div>
